import React from "react"
import PropTypes from "prop-types"

function cardTrayEnabled() {
  if (typeof window === "undefined") return false
  return Boolean(
    window.MTGGoldfish &&
    window.MTGGoldfish.features &&
    window.MTGGoldfish.features.cardTray
  )
}

function CardTrayMenu({ card, imageMenu = false, imageMenuDfc = false }) {
  if (!cardTrayEnabled()) return null
  const cardUuid = card && (card.card_uuid || card.cardUuid)
  if (!card || !cardUuid) return null

  const classes = ["dropdown", "deck-preview-actions", "card-tray-card-menu"]
  if (imageMenu) classes.push("card-tray-image-menu")
  if (imageMenu && imageMenuDfc) classes.push("card-tray-image-menu-dfc")
  const className = classes.join(" ")
  const buttonClasses = [
    "btn",
    "btn-sm",
    "dropdown-toggle",
    "deck-preview-actions-toggle",
    "card-tray-menu-button",
  ]
  if (imageMenu) buttonClasses.push("btn-secondary")
  const detailsUrl = card.links && card.links.default ? card.links.default : "#"
  const displayName = card.display_name || card.displayName || card.name || "card"
  const priceAlertCardId = card.name || displayName
  const priceAlertUrl = `/price_alerts?card_id=${encodeURIComponent(priceAlertCardId)}&type=paper`

  const menu = (
    <span
      className={className}
      data-card-tray-card="true"
      data-card-uuid={cardUuid}
      data-card-url={detailsUrl}
    >
      <button
        type="button"
        className={buttonClasses.join(" ")}
        aria-label="Card actions"
        title="More actions"
        data-bs-toggle="dropdown"
      >
        <span className="fa fa-ellipsis-v" aria-hidden="true" />
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        <li><a className="dropdown-item" href={detailsUrl}>View Card Details</a></li>
        <li><hr className="dropdown-divider" /></li>
        <li><button className="dropdown-item" type="button" data-card-tray-card-action="add">Add to Card Tray</button></li>
        <li><hr className="dropdown-divider" /></li>
        <li><a className="dropdown-item" href={priceAlertUrl}>Create Price Alert</a></li>
      </ul>
    </span>
  )

  if (!imageMenu) return menu

  return (
    <>
      {menu}
      <button
        type="button"
        className="btn btn-sm card-tray-image-add"
        data-card-tray-card="true"
        data-card-uuid={cardUuid}
        data-card-url={detailsUrl}
        data-card-tray-card-action="add"
        data-card-tray-display-name={displayName}
        aria-label={`Add ${displayName} to Card Tray`}
      >
        + Tray
      </button>
    </>
  )
}

CardTrayMenu.propTypes = {
  card: PropTypes.object,
  imageMenu: PropTypes.bool,
  imageMenuDfc: PropTypes.bool,
}

export default CardTrayMenu
